const adminPaths = [
  {
    path: 'dashboard',
    view: 'admin/Dashboard',
    title: 'Admin Dashboard',
  },
  {
    path: 'users',
    view: 'admin/Users',
    title: 'Admin Users',
  },
  {
    path: 'sites',
    view: 'admin/Sites',
    title: 'Admin Sites',
  },
  {
    path: 'allocation-units',
    view: 'admin/AllocationUnits',
    title: 'Admin Allocation Units',
  },
  {
    path: 'chemicals',
    view: 'admin/Chemicals',
    title: 'Admin Chemicals',
  },
  {
    path: 'email-reports',
    view: 'admin/Subscriptions',
    title: 'Admin Email Reports',
  },
  {
    path: 'users/create',
    view: 'single/UserCreate',
    title: 'Create User',
  },
  {
    path: 'users/:resource_id',
    view: 'single/UserEdit',
    title: 'Edit User',
  },
  {
    path: 'sites/create',
    view: 'single/SiteCreate',
    title: 'Create Site',
  },
  {
    path: 'sites/:resource_id',
    view: 'single/SiteEdit',
    title: 'Edit Site',
  },
  {
    path: 'allocation-units/create',
    view: 'single/AllocationUnitCreate',
    title: 'Create Allocation Unit',
  },
  {
    path: 'allocation-units/:resource_id',
    view: 'single/AllocationUnitEdit',
    title: 'Edit Allocation Unit',
  },
  {
    path: 'chemicals/create',
    view: 'single/ChemicalCreate',
    title: 'Create Chemical',
  },
  {
    path: 'chemicals/:resource_id',
    view: 'single/ChemicalEdit',
    title: 'Edit Chemical',
  },
  {
    path: 'email-reports/create',
    view: 'single/SubscriptionCreate',
    name: 'Create Admin Subscription',
    title: 'Create Subscription',
  },
  {
    path: 'email-reports/:resource_id',
    view: 'single/SubscriptionEdit',
    name: 'Edit Admin Subscription',
    title: 'Edit Subscription',
  },
];

adminPaths.forEach((path) => {
  path.isAdmin = true;
});

export default adminPaths;
